import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ServicePurchaseForm } from './ServicePurchases'

type ServicePurchase = {
  id: string
  number?: string
  date: string
  supplier: { id: string; name: string; club?: { id: string; name: string } }
  totalAmount: number
  status: string
  comment?: string
  expenseArticle?: { id: string; code: string; name: string }
  items: Array<{
    id: string
    tournamentId: string
    courtId: string
    tournament: { id: string; name: string }
    court: { name: string }
    startTime: string
    endTime: string
    hours: number
    ratePerHour: number
    amount: number
    comment?: string
  }>
}

const ServicePurchaseNew: React.FC = () => {
  const navigate = useNavigate()
  const [prefilledData, setPrefilledData] = useState<any>(null)
  const [showForm, setShowForm] = useState(false)

  useEffect(() => {
    // Получаем предзаполненные данные из sessionStorage
    const savedData = sessionStorage.getItem('newServicePurchaseData')
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData)
        console.log('Предзаполненные данные из sessionStorage:', parsedData)
        setPrefilledData(parsedData)
        // Очищаем sessionStorage после использования
        sessionStorage.removeItem('newServicePurchaseData')
      } catch (error) {
        console.error('Ошибка парсинга предзаполненных данных:', error)
      }
    }
    
    // Показываем форму после загрузки данных
    setShowForm(true)
  }, [])

  const handleFormClose = () => {
    navigate('/service-purchases')
  }

  // Создаем объект purchase на основе предзаполненных данных
  const createPurchaseFromPrefilledData = (): ServicePurchase | null => {
    if (!prefilledData) return null

    return {
      id: '', // Новый документ
      date: prefilledData.date,
      supplier: prefilledData.supplier || { 
        id: '', // Будет найден в форме по имени
        name: prefilledData.supplier?.name || '' 
      },
      totalAmount: prefilledData.items.reduce((sum: number, item: any) => sum + (item.amount || 0), 0),
      status: 'DRAFT',
      comment: '',
      items: prefilledData.items.map((item: any, index: number) => ({
        id: `prefilled_${index}`,
        tournamentId: item.tournamentId,
        courtId: item.courtId,
        tournament: { id: item.tournamentId, name: '' }, // Будет заполнено из справочника
        court: { name: '' }, // Будет заполнено из справочника
        startTime: item.startTime,
        endTime: item.endTime,
        hours: item.hours,
        ratePerHour: item.ratePerHour,
        amount: item.amount,
        comment: item.comment || '' // Пустой комментарий
      }))
    }
  }

  if (!showForm) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-600">Загрузка...</div>
        </div>
      </div>
    )
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Создание закупки услуг</h1>
        <p className="text-gray-600 mt-2">
          {prefilledData ? 'Заполните форму на основе резервирования кортов' : 'Заполните форму закупки услуг'}
        </p>
      </div>
      
      {showForm && (
        <ServicePurchaseForm
          purchase={createPurchaseFromPrefilledData()}
          isCopying={false}
          onClose={handleFormClose}
        />
      )}
    </div>
  )
}

export default ServicePurchaseNew
